'use strict';

var React = require('react');

var SvgMeasurementMinor = function SvgMeasurementMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m6 5.414.293.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-2-2a.999.999 0 0 0-1.414 0l-2 2a.999.999 0 1 0 1.414 1.414l.293-.293v6.586a1 1 0 1 0 2 0v-6.586Zm9.707 12.293 2-2a.999.999 0 0 0 0-1.414l-2-2a.999.999 0 1 0-1.414 1.414l.293.293h-6.586a1 1 0 1 0 0 2h6.586l-.293.293a.997.997 0 0 0 0 1.414.999.999 0 0 0 1.414 0Zm-5.707-12.707a1 1 0 0 1 0-2h1a1 1 0 1 1 0 2h-1Zm6 6a1 1 0 0 0 1-1v-1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1Zm1-6a1 1 0 1 1-2 0 1 1 0 1 1 0-2h1a1 1 0 0 1 1 1v1Z"
  }));
};

exports.SvgMeasurementMinor = SvgMeasurementMinor;
